<template>
  <button
    :disabled="isButtonDisable"
    :style="{
      background,
      height,
      borderRadius: `${borderRadius}px`,
      cursor: isButtonDisable ? 'not-allowed' : 'pointer'
    }"
    class="button-container"
    @click="onButtonClick"
  >
    <CircularProgress v-if="loading" class="circular-progress" :size="1" :width="2" />
    <div v-if="!loading" :style="{ color: isButtonDisable ? 'rgba(0, 0, 0, 0.26)' : textColor }" class="center">
      <slot></slot>
    </div>
  </button>
</template>

<script>
import CircularProgress from './CircularProgress.vue';

export default {
  name: 'GoldcastButton',
  components: {
    CircularProgress
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '30px'
    },
    backgroundColor: {
      type: String,
      default: '#0075ff'
    },
    textColor: {
      type: String,
      default: '#fff'
    },
    borderRadius: {
      type: Number,
      default: 16
    }
  },
  computed: {
    background() {
      return this.isButtonDisable ? 'rgba(0, 0, 0, 0.12)' : this.backgroundColor;
    },
    isButtonDisable() {
      return this.loading || this.disable;
    }
  },
  methods: {
    onButtonClick(event) {
      this.$emit('onClick', event);
    }
  }
};
</script>

<style lang="scss" scoped>
.button-container {
  padding: 0 16px;
  min-width: 64px;
  border: none;

  .circular-progress {
    margin: auto;
  }
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
